var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('ComputacionNavar'),_c('BannerComputacion'),_c('CategoriasComputacion'),_c('ComputacionFqa'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }